"use strict";

import angular from "angular";

import template from "./list-collapse-checkbox.component.html";
import "./list-collapse-checkbox.scss";
class ListCollapseCheckbox {
    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit() {}

    toggleChildrens(index) {
        this.openedSubChildren = false;
        if (this.opened === index) return (this.opened = false);
        this.opened = index;
    }

    toggleSubChildrens(index) {
        if (this.openedSubChildren === index)
            return (this.openedSubChildren = false);
        this.openedSubChildren = index;
    }

    isIndeterminate(item) {
        let subSelecteds = [];
        const selecteds = item.childrens.filter((children) => {
            if (!children.childrens) {
                item.isIndeterminate = false;
                return children.selected;
            }
            children.childrens.forEach((subchildren) => {
                subSelecteds = subSelecteds.concat(
                    subchildren.selected || false
                );
            });
        });

        if (subSelecteds.length) {
            if (
                subSelecteds.indexOf(true) > -1 &&
                subSelecteds.indexOf(false) > -1
            ) {
                item.isIndeterminate = true;
            } else {
                item.isIndeterminate = false;
            }
            return false;
        }

        if (
            selecteds.length === item.childrens.length ||
            selecteds.length === 0
        )
            return false;
        return true;
    }

    isChecked(childrens) {
        if (childrens?.length === 0) return false;
        const hasNotSelected = childrens.find((children) => !children.selected);
        if (hasNotSelected) return false;
        return true;
    }

    checkAll(childrens) {
        let toggle = true;
        if (this.isChecked(childrens)) toggle = false;
        childrens = childrens.map((children) => {
            children.selected = toggle;
            if (children.childrens) {
                children.childrens = children.childrens.map((subchildren) => {
                    subchildren.selected = toggle;
                    return subchildren;
                });
            }
            return children;
        });
        if (this.handleSelect) this.handleSelect();
    }

    getPositionOnSelected(item) {
        if (this.mode != "pushList") return;
        if (!item) return "";
        const index = this.itemsSelected.findIndex(
            (itemSelected) => itemSelected._id === item._id
        );
        if (index === -1) return "";
        const position = index + 1;
        return `${position}º`;
    }

    onToggleItem(item) {
        this.toggleItem(item);
        if (this.handleSelect) this.handleSelect();
    }

    toggleItem(item) {
        if (this.mode != "pushList") return;
        if (!item) return;
        const itemIndex = this.itemsSelected.findIndex(
            (itemSelected) => itemSelected._id === item._id
        );
        let selected = false;
        if (itemIndex > -1) {
            selected = false;
            this.itemsSelected.splice(itemIndex, 1);
        } else {
            selected = true;
            this.itemsSelected.push(item);
        }
        setTimeout(() => {
            for (const i of this.items) {
                for (const children of i.childrens) {
                    if (children._id === item._id) {
                        children.selected = selected;
                    }
                }
            }
            this.$scope.$applyAsync();
        }, 500);
    }

    toggleAllChildrens(item) {
        if (this.mode != "pushList") return;
        if (!item) return;
        const hasChildrensSelected = item.childrens.some((children) =>
            this.itemsSelected.find(
                (itemSelected) => itemSelected._id === children._id
            )
        );
        const itemsNotSelected = item.childrens.filter((i) => {
            return !this.itemsSelected.find(
                (itemSelected) => itemSelected._id === i._id
            );
        });
        if (hasChildrensSelected && itemsNotSelected?.length) {
            itemsNotSelected.forEach((children) => {
                this.toggleItem(children);
            });
        } else {
            item.childrens.forEach((children) => {
                this.toggleItem(children);
            });
        }
    }
}

ListCollapseCheckbox.$inject = ["$scope"];

const component = {
    bindings: {
        items: "=",
        opened: "<",
        itemsSelected: "=",
        mode: "@",
        handleSelect: "&"
    },
    controller: ListCollapseCheckbox
};

const name = "listCollapseCheckbox";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
